import { render, staticRenderFns } from "./PerformDashLayout.vue?vue&type=template&id=2582158c&"
import script from "./PerformDashLayout.vue?vue&type=script&lang=js&"
export * from "./PerformDashLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports